// 2차 6종(빔·장판·기둥·폭발·소용돌이·오라)이 같이 쓰는 머티리얼 틀: 투명 · 깊이 쓰기 없음 · 양면 · 안개 없음.
// 1차 모듈은 각자 같은 설정을 직접 적었다(그대로 둔다). 새 모듈은 이 함수로 만든다.
import * as THREE from 'three/webgpu';
import type { Node } from 'three/webgpu';

export interface FxMaterialOpts {
  /** 기본 가산. 연기처럼 어두운 색이 필요한 모듈만 NormalBlending */
  blending?: THREE.Blending;
}

export function fxMaterial(colorNode: Node<'vec3'>, opacityNode: Node<'float'>, o: FxMaterialOpts = {}): THREE.MeshBasicNodeMaterial {
  const m = new THREE.MeshBasicNodeMaterial();
  m.transparent = true;
  m.depthWrite = false;
  m.side = THREE.DoubleSide;
  m.blending = o.blending ?? THREE.AdditiveBlending;
  m.forceSinglePass = true;
  m.fog = false;
  m.colorNode = colorNode;
  m.opacityNode = opacityNode;
  return m;
}
